import { Component, OnInit, Input, ViewChild, ChangeDetectorRef, OnDestroy, ElementRef, DoCheck } from '@angular/core';
import { ProjectData } from 'src/app/entities/project-data.entity';
import { ModelService } from 'src/app/services/model.service';
import { ProjectDataPerimetro } from 'src/app/entities/project-data-perimetro.entity';
import { ConfigService } from 'src/app/app.config';
import { AlertData } from 'src/app/alert/alert-data.entity';
import { ProjectDataPuerta } from 'src/app/entities/project-data-puerta.entity';
import { Utils } from 'src/app/utils.module';
import { BuilderHistorialService } from '../builder-historial.service';
import { NewProjectData } from 'src/app/entities/new-project.entity';
import { Router } from '@angular/router';
import { AlertDataTypes } from 'src/app/alert/alert-data.types';
import { Subscription } from 'rxjs';
import { BuilderService } from '../builder.service';
import { ProjectDataProducto } from 'src/app/entities/project-data-producto.entity';
import { PathMap } from './path-map';
import { ProjectDataSatelite } from 'src/app/entities/project-data-satelite';
import { PropagarService } from 'src/app/services/propagar.service';
import { CoorMaps } from '../scheme3d/coor-maps';
import { LoaderComponent } from '../../loader/loader.component';
import { BudgetSatelite } from '../budget-satelite';
import { UtilsBuilder } from '../utils-builder';
import { MinisService } from '../../services/minis.service';
import { MODE } from '../bulder-datas';

import { Store } from '@ngrx/store';
import * as pathActions from '../../store/path/path.actions';
import * as actionsPath from '../../store/path/path.actions';

import { setMode } from 'src/app/store/builder/builder.actions';
import { ProjectDataStatusList } from 'src/app/entities/project-data-status.list';
import { AlertComponent } from 'src/app/alert/alert.component';
import { AppState } from 'src/app/app.reducers';

@Component({
	selector: 'app-gmaps-renderer',
	templateUrl: './gmaps-renderer.component.html',
	styleUrls: ['./gmaps-renderer.component.scss']
})
export class GmapsRendererComponent implements OnInit, OnDestroy, DoCheck {

	//#region #################### Constantes
	// MODE2D: Estado por defecto, se ve el editor de perímetros (Gmaps).
	// MODE3D: Visualizador de perímetros 3D (THREEjs).
	public readonly VIEW_MODE = { M2D: '2d', M3D: '3d' };

	private readonly COLOR_NORMAL = '#FFBA00';		// Perímetro.
	private readonly COLOR_DELETE = '#FF0000';		// Borrar puertas o perímetro.
	private readonly COLOR_SELECTED = '#0000FF';	// Perímetro seleccionado.
	private readonly COLOR_TOUCH = '#FFF700';		// Tocar perímetro.
	private readonly COLOR_TEXT = '#FF8200';		// Color de texto.
	private readonly COLOR_DOOR_NORMAL = '/assets/img/door.png';		// Icono puerta normal.
	private readonly COLOR_DOOR_DELETE = '/assets/img/door_red.png';	// Icono puerta tocada para borrar.

	// Utilizados por el TOOLBAR, opciones.
	public readonly OPTIONS: any = {
		DRAG: 'drag',
	};
	// Utilizados por el TOOLBAR, modos.
	/*private readonly MODE: any = { DRAG: 'dragMode', DRAW: 'drawMode',	DOOR: 'doorMode', ERASE: 'eraseMode', };*/

	// nivel mínimo de zoom
	private readonly MIN_ZOOM: number = 9;

	// Nivel máximo -- evita entrar en modo 3d. Alternativa: cargar mapa en modo terrain.
	private readonly MAX_ZOOM: number = 21;
	//#endregion

	//#region #################### @ViewChildren's
	@ViewChild('newProjectWindow') newProjectWindow: any;
	@ViewChild('loader') loader: LoaderComponent;
	@ViewChild('gmap') mapElement: any;
	@ViewChild('searchBox', { static: false }) searchElementRef: ElementRef;
	@ViewChild('alertWindow') alertWindow: AlertComponent;
	//#endregion

	//#region #################### @Input's
	@Input() projectData: ProjectData;
	@Input() isDisabled: boolean = false;
	//#endregion

	//#region #################### @Output's
	//#endregion

	//@Input() isDisabled2: boolean = false;
	//Output() onLocationChanged: EventEmitter<any> = new EventEmitter<boolean>();

	//#region #################### Parámetros globales.
	// Altual modo de vista 2D o 3D.
	public currentViewMode: string = this.VIEW_MODE.M2D;		// MVC acción.

	// Si se pona a true activa pantalla completa.
	public fullscreen = false;									// MVC acción.

	// Variables usadas por el Localizador de Google.
	public searchString: string = '';
	public autocomplete: google.maps.places.Autocomplete;
	public isInitialized = false;
	public place: google.maps.places.PlaceResult;

	// Muestra u oculta la animación de carga.
	public loading = false;
	//#endregion

	//#region #################### Parámetros locales.

	// Arreglo de subscribes, utilizado para liberarlos todos al mismo tiempo.
	private subscriptions: Subscription[] = [];

	// Coordenadas centrales.
	private lat = 41.3047326; // 41.75786995;
	private lng = 2.0859696; // 2.03118204;

	// Puntero a GoogleMap.
	private currentMap: google.maps.Map;

	// Array con los paths para Gmap.
	private paths: PathMap[]; // google.maps.Polyline[].

	// Indice del perímetro que ha sido seleccionado.
	// Ocurre cuando se pasa de ESTADO_DRAG a ESTADO_SELECT
	public indexPerimeterSelected = -1;		// -1 no hay perímetro seleccionado.

	//private drawingManager: google.maps.drawing.DrawingManager;
	//#endregion

	//public id: string = Utils.SATELITE;
	public selectedOverlay: any;
	//public current Renderer: any; //Renderer2D;
	//public currentZoom: number = 14;
	public selectedDoor: any;

	public totalLength = 0;
	public totalLengthStr = '0,00';
	public totalLengthErr = false;
	public prevDrawingMode: string = 'pointer';
	public currentDrawingMode: string = 'polyline';
	//public current LineColor: string = ' #FFBA00';
	//public current TextColor: string = '#FF8200';
	//public curren tDrawingOptions: any = { strokeColor: this.COLOR_NORMAL, strokeWeight: 5 };

	public currentOption: string = this.OPTIONS.DRAW_LINES;
	public currentDrawing: string = MODE.DRAG;
	public minimized: boolean = false;
	public disabledToolBox = false;

	private angularPatetico = false;

	private _tiempoMaxWaitBudget = 0;

	public isMinimized: boolean = true;

	private _iComingFrom3D = false;

	// #################### CODE
	constructor(
		private store: Store<AppState>,
		public modelService: ModelService,
		private ref: ChangeDetectorRef,
		public historialService: BuilderHistorialService,
		private builderService: BuilderService,
		private router: Router,
		private minisService: MinisService
	) {
		const bBtnSee: boolean = (localStorage.getItem('bBtnSee') === 'true');
		if (bBtnSee) { this.isMinimized = bBtnSee; }
	}

	// Necesario para actualizar la pantalla cuando se viene de otro sitio, angular es impotente 100%.
	ngDoCheck(): void {
		if (this.angularPatetico) {
			let obj = window.document.getElementById("idMap");
			if (obj) {
				this.angularPatetico = false;
				// console.log("updateSateliteMaps");
				this.updateSateliteMaps();
			}
		}
	}

	//#region #################### Eventos propios de angular.
	// Solo se ejecuta una vez.
	public ngOnInit() {

		this.escanearProyecto();

		// Captura cuando se navega por el historial.
		this.historialService.clearHistorial();
		this.subscriptions.push(this.historialService.onUpdateRenderer.subscribe((projectData: ProjectData) => {
			// Asigna el proyecto que hay en el historial.
			this.projectData = projectData;
		}));

		// Captura cuando se navega por el historial.
		this.subscriptions.push(this.historialService.onUpdateRenderer.subscribe((projectData: ProjectData) => {
			// Asigna el proyecto que hay en el historial.
			this.projectData = projectData;
			this.initDrawMap();
		}));

		this.subscriptions.push(this.modelService.sendForAprovalSatelite.subscribe((value: string) => {
			this.sendForAproval();
		}));

		this.store.subscribe(state => {
			this._iComingFrom3D = state.uiPath.iComingFrom3D;
		});

		// Subscribirse al evento global 'GProjectLoad' provocado en la carga de un proyecto.
		PropagarService.get('GProjectLoadSatelite').subscribe((data: any) => {
			// Actualiza el proyecto desde el local Storage.
			// Poner en modo esquema.
			if (!this._iComingFrom3D) this.currentViewMode = this.VIEW_MODE.M2D;

			this.escanearProyecto();

			//this.set CurrentMode(MODE.DRAG);
			//this.currentDrawing === MODE.DRAG;
			this.historialService.clearHistorial();
			this.historialService.addHistorial(this.projectData);

			this.initDrawMap(); // Limpia googleMaps.
			Utils.DOMWebHeader_setTitleProject(this.projectData.nombre);

			this.minisService.cacheCoordinates(this.projectData);
			//console.log(JSON.stringify(this.projectData.perimetro[0].coordenadas));

			let str = ProjectDataStatusList.find(item => item.value === this.projectData.estado);
			let text = this.modelService.getString('builder_status') + ' : ';
			text += ((str) ? this.modelService.getString(str.label) : this.modelService.getString('project_list_state_draft'));
			Utils.DOMWebHeader_setStatusProject(text);

			//this.auto Salvado();
			this.angularPatetico = true;
		});

		// A falta de REDUX buenas son TORTAS.
		PropagarService.get('GProjectChangeMCSatelite').subscribe((mc: number) => {
			//console.log(`>>> MC:: projectData.mc = ${this.projectData.mc}, mc = ${mc} `);
			this.projectData.mc = mc;
		});
	}

	public handleStateSee(): void {
		this.isMinimized = !this.isMinimized;
		localStorage.setItem('bBtnSee', this.isMinimized.toString());
	}

	// ### El proyecto viene del listado de proyectos o de OnInit (primera carga).
	private escanearProyecto() {
		// Iniciar el proyecto, primero comprobar si hay un proyecto en el local Storage.
		this.projectData = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));

		// Si llegados a este punto sigue siendo nulo, se crea un nuevo proyecto.
		if (!this.projectData) {
			this.projectData = new ProjectData();
			this.projectData._id = '';
			this.projectData.nombre = '';
			this.projectData.estado = 0; // Borrador.
			this.projectData.renderer = Utils.SATELITE;
			this.projectData.fechaCreacion = new Date();
			this.projectData.userId = this.modelService.getUser().getData().id;
			this.projectData.idioma = this.modelService.getLanguage().currentLanguage;
			this.projectData.userIdRivisa = this.modelService.getUser().getData().numCliRivisa;
			this.projectData.satelite = new ProjectDataSatelite(); // lat:0, lng:0, zoom:4
			this.projectData.perimetro = [];
		}
		else {
			// Asegurarse que tiene el userId.
			if (!this.projectData.userId || this.projectData.userId === '') this.projectData.userId = this.modelService.getUser().getData().id;

			// Asegurarse que tiene el idioma.
			if (!this.projectData.idioma) this.projectData.idioma = this.modelService.getLanguage().currentLanguage;

			// Limpiar perímetros vacios o con una coordenada (un perímetro debe tener como mínimo dos coordenadas).
			let newPerimetros = [];
			for (let p of this.projectData.perimetro) if (p.coordenadas.length > 1) newPerimetros.push(p);
			this.projectData.perimetro = newPerimetros;

			// Si hay perímetros prepararlos al nuevo formato si es necesario.
			if (this.projectData.perimetro.length > 0) {
				// Se inicia sin ser formato antiguo.
				let oldFormat = false;

				// Recorrer los perímetros.
				for (let perimeter of this.projectData.perimetro) {
					// Comprobar si tiene formato antiguo.
					oldFormat = (perimeter.coordenadas[0].dots === undefined);

					//perimeter.longitud = 0;
					let newCoor = [];		// Nuevas coordenadas.
					let newTramos = [0];	// Nuevos tramos.

					// Recorrer todas las coordenadas.
					for (let index = 0; index < perimeter.coordenadas.length; index++) {
						let coordenada = perimeter.coordenadas[index];
						let coorMaps = new CoorMaps(0, 0);

						if (oldFormat) {
							coorMaps.dots[0].lat = coordenada.lat;
							coorMaps.dots[0].lng = coordenada.lng;
						} else {
							coorMaps.dots[0].lat = coordenada.dots[0].lat;
							coorMaps.dots[0].lng = coordenada.dots[0].lng;
						}

						if (index > 0) {
							let longitud = google.maps.geometry.spherical.computeDistanceBetween(
								new google.maps.LatLng(newCoor[index - 1].dots[0].lat, newCoor[index - 1].dots[0].lng),
								new google.maps.LatLng(coorMaps.dots[0].lat, coorMaps.dots[0].lng)
							);
							//perimeter.longitud += longitud;
							newTramos.push(longitud);
						}
						newCoor.push(coorMaps);
					}
					perimeter.coordenadas = newCoor;
				}

				// Guardar en local.
				localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));
				//this._actualizar Salvado();
				this.saveToNode();
			}
		}
	}

	// ###
	public ngAfterViewInit() {
		// console.log("[ngAfterViewInit] updateSateliteMaps");
		this.updateSateliteMaps();
	}
	private updateSateliteMaps() {
		const mapProperties = {
			center: new google.maps.LatLng(this.lat, this.lng),
			scaleControl: true,
			zoom: 21,//9,
			tilt: 0,
			maxZoom: this.MAX_ZOOM,
			minZoom: this.MIN_ZOOM,
			rotateControl: false,
			zoomControl: false,
			mapTypeControl: false,
			streetViewControl: false,
			fullscreenControl: false,
			mapTypeId: google.maps.MapTypeId.HYBRID,
		};
		if (this.mapElement) this.currentMap = new google.maps.Map(this.mapElement.nativeElement, mapProperties);
		else {
			let obj = window.document.getElementById("idMap");
			this.currentMap = new google.maps.Map(obj, mapProperties);
		}

		this.currentMap.addListener('click', (e) => { this.clickMap(e); });
		this.currentMap.addListener('zoom_changed', () => {
			if (this.projectData && this.projectData.satelite) this.projectData.satelite = this.getPositionZoomMap();
		});
		this.currentMap.addListener('dragend', () => {
			if (this.projectData && this.projectData.satelite) this.projectData.satelite = this.getPositionZoomMap();
		});

		// Resituar lat, lng y zoom.
		this.setPositionZoomMap();

		// Si no es borrador no puede editar.
		if (this.projectData.estado > 0) {
			this.disabledToolBox = true;
		}else{//en caso de ser un proyecto en estado borrador, false para que puedas acceder a la barra de herramientas
			this.disabledToolBox = false;
		}


		// 3D siempre oculto en inicializar.
		this.currentViewMode = this.VIEW_MODE.M2D;
		this.indexPerimeterSelected = -1;
		if (this.projectData.perimetro.length === 0) {
			this.drawDrawMode();
		}
		else {
			this.drawDragMode();
		}

		// Dibujar perímetros, para evitar que angular se queje.
		setTimeout(() => { this.initDrawMap(); }, 500);

		// SearchBox loaclizador de Google
		this.autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
		this.autocomplete.addListener('place_changed', () => {
			if (!this.autocomplete) return;
			this.place = this.autocomplete.getPlace();
			if (this.place.geometry === undefined) return;
			this.lat = this.place.geometry.location.lat();
			this.lng = this.place.geometry.location.lng();

			// En caso de no tener perímetros definidos, se permite conservar el proyecto.
			if (!this.havePerimeters()) {
				// Limpiar historial.
				this.historialService.clearHistorial();

				// Situarse en el nuevo sitio.
				this.projectData.satelite.lat = this.lat;
				this.projectData.satelite.lng = this.lng;
				this.currentMap.setCenter(new google.maps.LatLng(this.lat, this.lng));
				this.currentMap.setZoom(this.MAX_ZOOM);
				this.projectData.satelite.zoom = this.MAX_ZOOM;
			}
			// Tiene perímetros, se debería avisar o cerrar y crear un nuevo proyeto.
			else {
				// Crear un proyecto nuevo sin AVISAR al usuario, por gentileza de Rivisa.
				// Salvar proyecto actual.
				if (this.projectData.nombre !== '') this.saveToNode();

				// Crear el popup (formulario) de satélite para la inserción del nombre o cancelación.
				const newProjectData: NewProjectData = new NewProjectData();
				// Mostrar el popup.
				newProjectData.message = this.modelService.getString('app_new_proyect_google');
				newProjectData.title = this.modelService.getString('win_new_project_title');
				newProjectData.type = 'modal';
				this.newProjectWindow.show(1, newProjectData);

				// Capturar la respuesta y actuar en consecuencia.
				const remSubscription = this.modelService.newProjectResultSignal
					.subscribe(
						(dt: NewProjectData) => {
							if (dt.estado === 1) { // Solo esquema.
								remSubscription.unsubscribe();			// Desubcribirse.
								this.newProjectWindow.close();			// Cerrar el popup.

								// Crear el proyecto limpio.
								this.projectData = new ProjectData();
								this.projectData.fechaCreacion = new Date();	// Almacenar la fecha actual.
								this.projectData.perimetro = [];				// Asegurarse que tiene un array vacío.
								this.projectData.nombre = dt.nombre;			// Almacenar el nombre del proyecto.
								this.projectData.renderer = Utils.SATELITE;		// Indicar el tipo.
								this.projectData.idioma = this.modelService.getLanguage().currentLanguage;	// Actualiza idioma del proyecto.
								this.projectData.satelite = new ProjectDataSatelite();
								this.projectData.satelite.lat = this.place.geometry.location.lat()
								this.lat = this.projectData.satelite.lat;
								this.projectData.satelite.lng = this.place.geometry.location.lng();
								this.lng = this.projectData.satelite.lng;

								// Limpiar historial.
								this.historialService.clearHistorial();

								// Almacenar el nuevo proyecto en el local Storage.
								localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));

								// Forzar el refresco del título del proyecto en la UI.
								Utils.DOMWebHeader_setTitleProject(dt.nombre);

								// Situarse en el nuevo sitio.
								this.currentMap.setCenter(new google.maps.LatLng(this.projectData.satelite.lat, this.projectData.satelite.lng));

								// Situarse en el nuevo sitio.
								this.currentMap.setCenter(new google.maps.LatLng(this.projectData.satelite.lat, this.projectData.satelite.lng));
								this.currentMap.setZoom(this.MAX_ZOOM);
								this.projectData.satelite.zoom = this.MAX_ZOOM;

								this.limpiarTodoGoogleMaps();
							}
						});
			}
		});
		this.isInitialized = true;
	}

	private havePerimeters(): boolean {
		if (this.projectData && this.projectData.perimetro) {
			if (this.projectData.perimetro.length > 0) {
				for (let p of this.projectData.perimetro) {
					if (p.coordenadas && p.coordenadas.length > 1) return true;
				}
			}
		}
		return false;
	}

	// Destructor.
	public ngOnDestroy(): void {
		// Liberar todos los subscribes.
		this.subscriptions.map((item: Subscription) => { item.unsubscribe(); });
	}
	//#endregion

	// ###
	private clickMap(event: any) {

		// Solo si está en modo Edición.
		if (this.currentDrawing !== MODE.DRAW) return;

		// Prepara las coordenadas.
		let coor = new CoorMaps(event.latLng.lat(), event.latLng.lng());

		// Si no hay perímetro seleccionado se asume un nuevo perímetro.
		if (this.indexPerimeterSelected < 0) {	// ##### NUEVO PERÍMETRO.

			// Crear un perímetro nuevo.
			let perimeter = new ProjectDataPerimetro();

			// Si existe ya un producto clonarlo y asignarlo.
			let producto = this.getCloneLastProduct();
			if (producto) perimeter.producto = producto;

			// Insertar el nuevo perímetro en el proyecto.
			this.projectData.perimetro.push(perimeter);

			// Coge el último perímetro como seleccionado (el último es el nuevo que se ha creado).
			this.indexPerimeterSelected = this.projectData.perimetro.length - 1;

			// Añade las coordenadas al nuevo perímetro.
			perimeter.coordenadas.push(coor);

			//con sole.log('NUEVO PEÍMETRO ' + this.index PerimeterSelected);
			// Crear un punto gráfico. Para el texto usar color FF8200.
			this._createPolyLine([coor], true, this.indexPerimeterSelected);
		}
		else { // AÑADIR PUNTOS AL PERÍMETRO SELECCIONADO.
			//con sole.log('MODIFICAR PEÍMETRO ' + this.index PerimeterSelected);
			// Insertar un nuevo punto.
			let poly = this.paths[this.indexPerimeterSelected].poly;
			let path = poly.getPath().getArray();
			path.push(new google.maps.LatLng(coor.dots[0].lat, coor.dots[0].lng));

			this.paths[this.indexPerimeterSelected].poly.setPath(path);
			this.projectData.perimetro[this.indexPerimeterSelected].coordenadas.push(coor);

			google.maps.event.addListener(poly.getPath(), 'insert_at', (index) => { this.event_insert_at(index); });
			google.maps.event.addListener(poly.getPath(), 'set_at', (index, obj) => { this.event_set_at(index, obj); });

			this.actualizarLongitudtotal();
			this.saveLocalRapido(true);
		}
	}

	// ###
	private limpiarTodoGoogleMaps() {
		// Limpiar google maps.
		if (this.paths) {
			for (let map of this.paths) {
				map.poly.setMap(null);
				for (let d of map.doors) d.door.setMap(null);
				for (let t of map.meters) t.setMap(null);
			}
		}
		this.paths = new Array<PathMap>();
	}

	// ### Iniciar perímetros.
	private initDrawMap() {
		// Limpiar google maps.
		this.limpiarTodoGoogleMaps();

		// Comprobar si tiene perímetros.
		if (this.projectData.perimetro.length === 0) {
			// Seleccionar el primer perimetro.
			this.indexPerimeterSelected = -1;
			this.drawDrawMode();
		}
		else {	// Existen perímetros, actualizarlos.
			for (let indexPerimeter = 0; indexPerimeter < this.projectData.perimetro.length; indexPerimeter++) {

				// Adquirir el perímetro.
				let perimetro = this.projectData.perimetro[indexPerimeter];

				// Si no tiene el parámetro coordenadas, crearlo.
				if (!perimetro.coordenadas) perimetro.coordenadas = [];

				// Reinicia los tramos.
				perimetro.tramos = [];

				// Crear el perímetro en google maps.
				let pathMap = this._createPolyLine(perimetro.coordenadas, false, indexPerimeter);

				// Como mínimo debe exsistir dos puntos en un perímetro.
				if (perimetro.coordenadas.length > 1) {
					perimetro.tramos.push(0);
					let total = 0;
					for (let coor = 0; coor < perimetro.coordenadas.length - 1; coor++) {
						let c1 = perimetro.coordenadas[coor];
						let c2 = perimetro.coordenadas[coor + 1];
						let dato = google.maps.geometry.spherical.computeDistanceBetween(
							new google.maps.LatLng(c1.dots[0].lat, c1.dots[0].lng),
							new google.maps.LatLng(c2.dots[0].lat, c2.dots[0].lng));

						//c1.es fe = dato;

						perimetro.tramos.push(dato);

						total += dato;

						let texto = dato.toFixed(2) + 'm';
						if ((coor + 2) == perimetro.coordenadas.length) texto += ' (' + total.toFixed(2) + 'm)';

						let text = new google.maps.Marker({
							position: { lat: c2.dots[0].lat, lng: c2.dots[0].lng },
							map: this.currentMap,
							label: { text: texto, color: this.COLOR_TEXT, fontWeight: 'bold' },
							icon: { url: '/assets/img/whitepixel.png', scaledSize: new google.maps.Size(0, 0), labelOrigin: new google.maps.Point(0, -8) }
						});
						pathMap.meters.push(text);
					}
				}
				else {
					perimetro.coordenadas = [];
					perimetro.tramos = [];
				}

				// Puertas, en caso de tener puertas crearlas y colocarlas.
				for (let door of perimetro.puertas) {
					// Longitud del tramo.
					let dist = perimetro.tramos[door.lsp + 1];
					let move = ((dist / 100) * door.margen);

					let a = pathMap.poly.getPath().getAt(door.lsp);
					let b = pathMap.poly.getPath().getAt(door.lsp + 1);
					let h = google.maps.geometry.spherical.computeHeading(a, b);
					let point = google.maps.geometry.spherical.computeOffset(a, move, h);

					this.createDoorGoogle(point, door, pathMap, indexPerimeter);
				}

				let __latlng = this.paths[indexPerimeter].poly.getPath().getArray(); // Obtener todos los puntos latlng.
				let last = __latlng.length - 1;
				let closet = (__latlng[0].lat() === __latlng[last].lat() && __latlng[0].lng() === __latlng[last].lng());
				let v3 = [];
				for (let i = 0; i < __latlng.length; i++) {
					let vec = UtilsBuilder.latLngToVector3d(__latlng[i].lat(), __latlng[i].lng());
					perimetro.coordenadas[i].dots[0].x = vec.x;
					perimetro.coordenadas[i].dots[0].y = vec.y;
					perimetro.coordenadas[i].dots[0].z = vec.z;
					v3.push(vec);
				}

				if (__latlng.length > 2) { // Angulos, debe exsitir como mínimo 3 postes.
					for (let i = 0; i < v3.length - 1; i++) {
						// Si el perímetro está cerrado obtener el angulo del primer poste.
						if (i === 0) { // Calcular el angulo del primer y último poste.
							if (closet)
								perimetro.coordenadas[0].ang = Utils.anguloEntreDos(v3[0].x, v3[0].y, v3[0].z, v3[last].x, v3[last].y, v3[last].z, v3[1].x, v3[1].y, v3[1].z);
						}
						else {
							perimetro.coordenadas[i].ang = Utils.anguloEntreDos(v3[i].x, v3[i].y, v3[i].z, v3[i - 1].x, v3[i - 1].y, v3[i - 1].z, v3[i + 1].x, v3[i + 1].y, v3[i + 1].z);
						}
					}
				}
				this.drawDragMode();
			}
			// Ajuste del perímetro seleccionado.
			if (this.indexPerimeterSelected >= this.paths.length) this.indexPerimeterSelected = -1;
		}

		this.saveLocalRapido(false);
		// Actualizar longitud total.
		this.actualizarLongitudtotal();

		//this.set CurrentMode(MODE.DRAG);
		//this.currentMap .setOptions({ draggabl eCursor: 'crosshair' });
		this.setPositionZoomMap();
	}

	// FIXME ###
	// Crea una puerta y la inserta en GMAP.
	private createDoorGoogle(point: google.maps.LatLng, door: ProjectDataPuerta, pathMap: PathMap, indexPerimeter: number) {
		let marker = new google.maps.Marker({ position: point, map: this.currentMap, icon: this.COLOR_DOOR_NORMAL });
		pathMap.doors.push({ door: marker, section: door.lsp });

		marker.addListener('mouseover', (e) => {
			let _door = marker;
			if (this.currentDrawing === MODE.ERASE) {
				_door.set('icon', this.COLOR_DOOR_DELETE);
			}
		});

		marker.addListener('mouseout', (e) => {
			let _door = marker;
			_door.set('icon', this.COLOR_DOOR_NORMAL);
		});

		marker.addListener('click', (e) => {
			let _indexPerimeter = indexPerimeter;
			let _door = door;
			let _doorMarker = marker;
			if (this.currentDrawing === MODE.ERASE) {

				let x = this.projectData.perimetro[_indexPerimeter].puertas.findIndex((e) => e == _door);
				this.projectData.perimetro[_indexPerimeter].puertas.splice(x, 1);

				x = this.paths[_indexPerimeter].doors.findIndex((e) => e == _doorMarker);
				_doorMarker.setMap(null);
				this.paths[_indexPerimeter].doors.splice(x, 1);

				this.saveLocal();
			}
		});
	}

	// ###
	public UIHidden(): boolean {
		return (this.projectData.estado != 0) || (this.currentViewMode !== this.VIEW_MODE.M2D);
	}

	// ###
	public UIMinimize(): boolean {
		return this.minimized || this.disabledToolBox;
	}

	// ###
	public handleState(): void {
		if (this.projectData.estado == 0) {
			this.minimized = !this.minimized;
		}
		else {
			this.minimized = true;
		}
	}
	// ###
	public ModeDrag(): boolean { return this.currentDrawing === MODE.DRAG; }			// MVC acción.
	// ###
	public ModeDraw(): boolean { return this.currentDrawing === MODE.DRAW; }			// MVC acción.
	// ###
	public ModeDoor(): boolean { return this.currentDrawing === MODE.DOOR; }			// MVC acción.
	// ###
	public ModeErase(): boolean { return this.currentDrawing === MODE.ERASE; }			// MVC acción.
	// ###
	public canDoor(): boolean { return (this.indexPerimeterSelected !== -1) && (this.currentDrawing !== MODE.DRAW); }

	// Poner en modo Drag.
	public drawDragMode(inspect: boolean = true) {
		// Si ya está en ese modo no hacer nada.
		if (inspect && this.currentDrawing === MODE.DRAG) return;
		this.currentMap.setOptions({ draggableCursor: 'grab', draggingCursor: 'grabbing' });

		// Si su anterior modo era DRAW.
		if (this.currentDrawing === MODE.DRAW) {

			// Sincronizar el último perímetro. Si solo tiene un punto eliminar.
			if (this.projectData.perimetro.length > 0) {
				let last = this.projectData.perimetro.length - 1;
				let perimeter = this.projectData.perimetro[last];

				if (perimeter.coordenadas) {
					if (perimeter.coordenadas.length > 1) {
						// Actualizar y sincronizar.
						perimeter.coordenadas = [];
						let polys = this.paths[last].poly.getPath().getArray();

						for (let point of polys) {
							perimeter.coordenadas.push(new CoorMaps(point.lat(), point.lng()));
						}
					}
					else {
						// Eliminar no deben existir perímetros de un solo punto.
						let obj = this.paths.pop();
						google.maps.event.clearInstanceListeners(obj.poly.getPath());
						obj.poly.setMap(null);
						this.projectData.perimetro.pop();
						this.indexPerimeterSelected = -1;
					}
				}
				this.saveLocal();
			}
			this.actualizarLongitudtotal();
		}

		this.store.dispatch(setMode({ mode: MODE.DRAG }));
		this.currentDrawing = MODE.DRAG;
	}

	// Clona el último producto del proyecto si no hay retorna undefined.
	private getCloneLastProduct(): ProjectDataProducto {
		for (let index = this.projectData.perimetro.length - 1; index > -1; index--) {
			let p = this.projectData.perimetro[index];
			if (p.producto !== undefined && p.producto.panel !== undefined && p.producto.tipoPanel !== undefined) {
				return JSON.parse(JSON.stringify(p.producto));
			}
		}
		return undefined;
	}

	private cleanAllColors() {
		// Actualizar los colores de los paths.
		if (this.paths.length > 0) {
			for (let iPath = 0; iPath < this.paths.length; iPath++) {
				this.paths[iPath].poly.set('strokeColor', this.COLOR_NORMAL);
			}
		}
		// TODO limpiar puertas
	}

	// ### Petición para activar la creación de un nuevo perímetro.
	public drawDrawMode() {
		if (this.currentDrawing === MODE.DRAW) return;

		// Actualizar los colores de los paths y puertas.
		this.cleanAllColors();

		this.currentMap.setOptions({ draggableCursor: 'crosshair', draggingCursor: 'move' });

		for (let p of this.paths) p.poly.setEditable(false);

		this.indexPerimeterSelected = -1;
		this.store.dispatch(setMode({ mode: MODE.DRAW }));
		this.currentDrawing = MODE.DRAW;
	}

	// ### Petición para activar el modo puertas.
	public drawDoorMode() {
		if (this.currentDrawing === MODE.DOOR) return;

		if (this.indexPerimeterSelected === -1) return;

		this.currentMap.setOptions({ draggableCursor: 'pointer', draggingCursor: 'grabbing' });
		this.store.dispatch(setMode({ mode: MODE.DOOR }));
		this.currentDrawing = MODE.DOOR;
	}

	// ### Petición para activar el modo de borrado (perímetros, puertas, elevaciones).
	public drawEraseMode() {
		if (this.currentDrawing === MODE.ERASE) return;

		this.currentMap.setOptions({ draggableCursor: 'pointer', draggingCursor: 'pointer' });
		this.store.dispatch(setMode({ mode: MODE.ERASE }));
		this.currentDrawing = MODE.ERASE;
	}

	// ###
	private actualizarPerimeter(indexPerimeter: number) {
		let path = this.paths[indexPerimeter];
		let paths = path.poly.getPath().getArray();
		let perimetro = this.projectData.perimetro[indexPerimeter];

		// Refresco de los tramos que componen el perímetro.
		perimetro.tramos = [0];
		for (let i = 0; i < paths.length - 1; i++) {
			perimetro.tramos.push(google.maps.geometry.spherical.computeDistanceBetween(paths[i], paths[i + 1]));
		}

		for (let i = 0; i < paths.length; i++) {
			// Mover textos.
			for (let old of path.meters) { old.setMap(null); }

			let total = 0;
			for (let t = 1; t < perimetro.tramos.length; t++) {
				let num = perimetro.tramos[t];
				total += num;

				let texto = num.toFixed(2) + 'm';
				if ((t + 1) == perimetro.tramos.length) texto += ' (' + total.toFixed(2) + 'm)';

				let text = new google.maps.Marker({
					position: { lat: paths[t].lat(), lng: paths[t].lng() },
					map: this.currentMap,
					label: { text: texto, color: this.COLOR_TEXT, fontWeight: 'bold' },
					icon: { url: '/assets/img/whitepixel.png', scaledSize: new google.maps.Size(0, 0), labelOrigin: new google.maps.Point(0, -8) }
				});
				path.meters.push(text);
			}

			// Resituar puertas.
			for (let old of path.doors) { old.door.setMap(null); }

			for (let door of perimetro.puertas) {
				let a = paths[door.lsp];
				let b = paths[door.lsp + 1];
				let dist = perimetro.tramos[door.lsp + 1];
				let move = ((dist / 100) * door.margen);
				let h = google.maps.geometry.spherical.computeHeading(a, b);
				let point = google.maps.geometry.spherical.computeOffset(a, move, h);

				this.createDoorGoogle(point, door, path, indexPerimeter);
			}
		}
	}

	// insert_at Rompe una línea creando un nuevo punto.
	private event_insert_at(index: number) {
		let perimeter = this.projectData.perimetro[this.indexPerimeterSelected];
		let points = this.paths[this.indexPerimeterSelected].poly.getPath().getArray();
		perimeter.coordenadas = [];

		//	let newCoor = [];
		let thereIsDoors = perimeter.puertas.length > 0;
		for (let point = 0; point < points.length; point++) {
			let p = points[point];
			perimeter.coordenadas.push(new CoorMaps(p.lat(), p.lng()));
		}

		if (thereIsDoors) { // Reordenar las puertas afectadas.
			// El resto de las puertas deben incrementar su línea (lsp).
			let doorsSiguientes = perimeter.puertas.filter(c => { return c.lsp >= index; });
			if (doorsSiguientes) {
				for (let i of doorsSiguientes) { i.lsp++; }
			}

			let doorsAntiguas = perimeter.puertas.filter(c => { return c.lsp == (index - 1); });
			if (doorsAntiguas) {
				for (let i of doorsAntiguas) {
					if (i.margen > 50) {
						// La puerta debe ser movida a la siguiente línea y debe perder el 50% de margen (lsp).
						i.lsp++;
						i.margen -= 50;
					}
				}
			}
		}

		// Tener en cuenta las puertas.
		this.actualizarPerimeter(this.indexPerimeterSelected);

		this.saveLocalRapido(true);
		this.actualizarLongitudtotal();
	}

	// set_at Modifica un punto.
	private event_set_at(index: number, obj: any) {
		let perimeter = this.projectData.perimetro[this.indexPerimeterSelected];
		let points = this.paths[this.indexPerimeterSelected].poly.getPath().getArray();
		perimeter.coordenadas = [];
		for (let point = 0; point < points.length; point++) {
			let p = points[point];
			perimeter.coordenadas.push(new CoorMaps(p.lat(), p.lng()));
		}
		this.actualizarPerimeter(this.indexPerimeterSelected);
		this.saveLocalRapido(true);
		this.actualizarLongitudtotal();
	}

	private erasePerimeter(poly: google.maps.Polyline) {
		for (let index = 0; index < this.paths.length; index++) {
			let pathMap = this.paths[index];

			if (poly === pathMap.poly) {
				google.maps.event.clearInstanceListeners(poly.getPath());
				pathMap.poly.setMap(null);

				for (let t of pathMap.meters) t.setMap(null);
				for (let d of pathMap.doors) d.door.setMap(null);

				this.paths.splice(index, 1);
				this.projectData.perimetro.splice(index, 1);

				if (this.indexPerimeterSelected === index) this.indexPerimeterSelected = -1;

				this.saveLocal();
				this.actualizarLongitudtotal();

				if (this.paths.length === 0) this.drawDrawMode();
			}
		}
	}

	// FIXME ###
	private insertDoor(latlng: google.maps.LatLng, poly: google.maps.Polyline, indexPerimetro: number, pathMap: PathMap) {
		if (this.indexPerimeterSelected !== indexPerimetro) return;

		// No se pueden poner más de cinco puertas por perímtero.
		if (this.projectData.perimetro[indexPerimetro].puertas.length >= 5) return;

		// Obtener el tramo.
		let c = []
		let aux = new google.maps.Polyline({
			path: c,
			geodesic: true,
			strokeColor: '#FFBA00',
			strokeOpacity: 1.0,
			strokeWeight: 4,
			map: null
		});

		let polyLine = poly.getPath().getArray();
		for (let idLine = 0; idLine < polyLine.length - 1; idLine++) {
			c = [
				new google.maps.LatLng(polyLine[idLine].lat(), polyLine[idLine].lng()),
				new google.maps.LatLng(polyLine[idLine + 1].lat(), polyLine[idLine + 1].lng())
			];
			aux.setPath(c);
			if (google.maps.geometry.poly.isLocationOnEdge(latlng, aux, 0.000001)) {
				// Obtener el % d la puerta.
				let distancia = google.maps.geometry.spherical.computeDistanceBetween(poly.getPath().getAt(idLine), poly.getPath().getAt(idLine + 1));

				//let distDoor = google.maps.geometry.spherical.compute Length(dist);
				let distDoor = google.maps.geometry.spherical.computeDistanceBetween(poly.getPath().getAt(idLine), latlng);
				let resto = distancia - distDoor;

				// Obtener el % desde punto A hasta el punto clicado.
				let tanto = parseFloat((100 - (resto / (distancia / 100))).toFixed(2));

				// Crear una puerta e insertarla.
				let puerta = new ProjectDataPuerta();
				puerta.lat = latlng.lat();
				puerta.lng = latlng.lng();
				puerta.lsp = idLine;		// Número de la línea.
				puerta.margen = tanto;		// % desde el punto A, siempre manda el poste según flujo de creación.

				this.projectData.perimetro[indexPerimetro].puertas.push(puerta);	// Insertar la puerta.
				// Almacenar la puerta en el local Storage.
				localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));

				this.createDoorGoogle(latlng, puerta, pathMap, indexPerimetro);
				this.saveLocal();

				// Quitar el modo puertas, después de colocar una puerta se desactiva el modo,
				// si se quiere colcar otra puerta se debe volver al modo door.
				this.drawDragMode();

				return;
			}
		}
		this.saveToNode();
	}

	// ### coor => [{lat:0,lng:0},...]
	private _createPolyLine(coor: any[], editable: boolean, perimetro: number) {
		let c = [];
		if (coor && coor.length > 0) {
			for (let item of coor) {
				c.push(new google.maps.LatLng(item.dots[0].lat, item.dots[0].lng));
			}
		}

		let pathMap = new PathMap();
		pathMap.poly = new google.maps.Polyline({
			path: c,
			editable: editable,
			geodesic: true,
			strokeColor: '#FFBA00',
			strokeOpacity: 1.0,
			strokeWeight: 6,
			map: this.currentMap
		});

		// Evento que es llamado cuando se divide una línea existente.
		google.maps.event.addListener(pathMap.poly.getPath(), 'insert_at', (index, obj) => { this.event_insert_at(index); });
		// Evento que es llamado cuendo se modifica un punto.
		google.maps.event.addListener(pathMap.poly.getPath(), 'set_at', (index, obj) => { this.event_set_at(index, obj); });

		pathMap.poly.addListener('mouseover', (e) => {
			let poly = pathMap.poly;
			let _perimeter = perimetro;
			if (this.currentDrawing === MODE.DRAG && _perimeter !== this.indexPerimeterSelected) {
				poly.set('strokeColor', this.COLOR_TOUCH);
			}
			else if (this.currentDrawing === MODE.ERASE) {
				poly.set('strokeColor', this.COLOR_DELETE);
			}
		});

		pathMap.poly.addListener('mouseout', (e) => {
			let poly = pathMap.poly;
			let _perimeter = perimetro;

			if (_perimeter === this.indexPerimeterSelected) {
				poly.set('strokeColor', this.COLOR_SELECTED);
			}
			else {
				poly.set('strokeColor', this.COLOR_NORMAL);
			}
		});
		/**Condición para bloquear el boton de configuración y el perímetro dibujado en estado diferente a borrador */


		if(this.projectData.estado==0){
			//funcion cuando el estado del proyecto es borrador, modifica el perímetro y puntos de control
			pathMap.poly.addListener('click', (e) => {

				let poly = pathMap.poly;
				let indexPerimetro = perimetro;

				// Click con modo borrar.
				if (this.currentDrawing === MODE.ERASE) {
					this.erasePerimeter(poly);
				}
				// Click con modo puerta.
				else if (this.currentDrawing === MODE.DOOR) {
					if (!e.vertex) this.insertDoor(e.latLng, poly, indexPerimetro, pathMap);
				}
				// Click para editar o modificar el perímetro.
				else {
					if (!poly.getEditable()) { // Poner en edición.
						// En modo nuevo no se debe seleccionar.
						if (this.currentDrawing === MODE.DRAW) return;
						for (let index = 0; index < this.paths.length; index++) {
							let polyLine = this.paths[index].poly;
							if (poly === polyLine) {
								poly.setEditable(true);
								// Limpiar el actual indexPerimeterSelected
								this.cleanAllColors();

								this.indexPerimeterSelected = index;
								poly.set('strokeColor', this.COLOR_SELECTED);
							}
							else {
								polyLine.setEditable(false);
							}
						}
					}
					else {
						// Solo cuando se crea por primera vez.
						if (this.currentDrawing !== MODE.DRAW) return;
						if (e.vertex !== undefined && e.vertex === 0 && poly.getPath().getLength() > 2) {
							// Unir.
							let p = poly.getPath();
							p.push(new google.maps.LatLng(e.latLng.lat(), e.latLng.lng()));
							poly.setPath(p);
							this.drawDragMode();
							this.saveLocalRapido(true);
						}
					}
				}
			});

		}
		this.paths.push(pathMap);
		return this.paths[perimetro];
}

	// ### No es lo más optimo y sería más apropiado actualizar el settings solo cuando es abierto.
	public getCurrentPerimeter(): ProjectDataPerimetro {
		if (this.currentDrawing !== MODE.DRAW) {
			let p = this.projectData.perimetro[this.indexPerimeterSelected];
			if (p && p.coordenadas && p.coordenadas.length > 1) return this.projectData.perimetro[this.indexPerimeterSelected];
		}
		return undefined;
	}

	// ### Actualiza la longitud total partiendo de paths (PolyLine).
	private actualizarLongitudtotal() {
		let total = 0;
		for (let obj of this.paths) {
			total += google.maps.geometry.spherical.computeLength(obj.poly.getPath());
		}
		this.totalLength = total;
		this.totalLengthStr = this.totalLength.toFixed(2);
	}

	// ###
	public btnEraseAll() {
		return (this.projectData && this.projectData.perimetro && this.projectData.perimetro.length && (this.currentDrawing === MODE.DRAW));
	}

	// ###
	public drawEraseAllMode() {
		this.limpiarTodoGoogleMaps();

		this.projectData.perimetro = [];
		//this.set CurrentMode(MODE.DRAW);
		this.indexPerimeterSelected = -1;

		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));
		this.historialService.addHistorial(this.projectData);

		this.saveToNode();

		this.actualizarLongitudtotal();
		this.drawDrawMode();
	}

	// ### Eventos de los botones TOOLBAR (Deshacer/Rehacer) del toolBar.
	public clickUndo() {									// MCV event.
		this.historialService.historialBack();
		this.indexPerimeterSelected = -1;
		this.drawDragMode();
		this.initDrawMap();
		this.saveToNode();
		//this._actualizar Salvado();
	}

	// ###
	public clickRedo() {									// MCV event.
		this.historialService.historialNext();
		this.indexPerimeterSelected = -1;
		this.drawDragMode();
		this.initDrawMap();
		this.saveToNode();
		//this._actualizar Salvado();
	}

	// ### Envia el proyecto al local Storage. Guarda en el historial si se le indica.
	public saveLocal() {
		if (!this.projectData) return;

		// Eliminar nulos.
		let perimeters = [];
		for (let per of this.projectData.perimetro) {
			if (per === undefined) continue;
			if (per.coordenadas === undefined) continue;
			if (per.coordenadas.length < 2) continue;
			perimeters.push(per);
		}
		this.projectData.perimetro = perimeters;

		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));
		this.historialService.addHistorial(this.projectData);
		this.saveToNode();
		//this._actualizar Salvado();
	}

	private saveLocalRapido(historial = false) {
		if (!this.projectData) return;
		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));
		if (historial) this.historialService.addHistorial(this.projectData);
		this.saveToNode();
	}

	// ###
	private getPositionZoomMap(): ProjectDataSatelite {
		let pds = new ProjectDataSatelite();
		pds.lat = this.currentMap.getCenter().lat();
		pds.lng = this.currentMap.getCenter().lng();
		pds.zoom = this.currentMap.getZoom();
		return pds;
	}

	// ###
	private setPositionZoomMap() {
		if (!this.projectData.satelite) this.projectData.satelite = new ProjectDataSatelite();

		this.currentMap.setCenter(new google.maps.LatLng(this.projectData.satelite.lat, this.projectData.satelite.lng));
		this.lat = this.projectData.satelite.lat;
		this.lng = this.projectData.satelite.lng;
		this.currentMap.setZoom(this.projectData.satelite.zoom);
		//this._actualizar Salvado();
		this.saveToNode();
	}

	// ###
	private budgetSatelite: BudgetSatelite;
	public sendForAproval() {
		// console.log('>>> Presupuesto');

		// Almacena dirección de retorno.
		this.store.dispatch(pathActions.goFront({ path: '/satelite' }));

		// Crear un nuevo presupuesto.
		this.budgetSatelite = new BudgetSatelite(this.projectData);

		// Avisa por consola si el _id del proyecto no existe o está vacío, no modifica.
		if (this.projectData._id == undefined || this.projectData._id == '') {
			// console.log('No tiene id proyecto');
		}

		// En caso de que el proyecto no tenga usuario le asigna el actual, esto no debería pasar.
		if (this.projectData.userId == undefined || this.projectData.userId == ''
			|| this.projectData.userIdRivisa == undefined || this.projectData.userIdRivisa == '') {

			// console.log('Se asigna el usuario loginado al proyecto actual.');
			this.projectData.userId = this.modelService.getUser().getData().id;
			this.projectData.userIdRivisa = this.modelService.getUser().getData().numCliRivisa;
		}

		// Si no tiene idioma asignado se le asigna el actual.
		if (!this.projectData.idioma) this.projectData.idioma = this.modelService.getLanguage().currentLanguage;

		// Guardar el actual zoom.
		this.projectData.satelite = this.getPositionZoomMap();

		this.budgetSatelite.createBudget();
		this._tiempoMaxWaitBudget = 0;
		this.waitBudgetSatelite(true);
	}

	public create3D() {
		// Guardar el actual zoom.
		this.projectData.satelite = this.getPositionZoomMap();
		this.currentViewMode = this.VIEW_MODE.M3D;
	}

	public onFinish3DKO() {
		const alertData = new AlertData();
		alertData.title = this.modelService.getString('satelite3d_error_titulo');
		alertData.messages = this.modelService.getString('satelite3d_error_mensaje').split('#');
		alertData.type = AlertDataTypes.ACCEPT;
		this.alertWindow.show(alertData);

		this.loading = false;
		this.currentViewMode = this.VIEW_MODE.M2D;
		this.projectData = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));
		this.angularPatetico = true;
	}

	public onFinish3DOK() {
		this.loading = false;
	}

	// Método que espera la gestión del presupuesto, si pasa el tiempo máximo sale y debe avisar que no se pudo realizar.
	private waitBudgetSatelite(verPresupuesto: boolean) {
		if (this.budgetSatelite.proccessEnd) {
			// Avisar si se excede de la longitud máxima.
			if (this.budgetSatelite.result.lengthExceeded) {
				// En caso de exceder la longitud máxima se avisa al usuario.
				let mensaje = this.modelService.getString('builder_error_max_length') + ' ' + this.getPerimeterTotalLength().toFixed(2) + ' ';
				mensaje += this.modelService.getString('builder_error_max_length_sub') + ' ' + ConfigService.MAX_PERIMETER_LENGTH_METERS + 'm)';
				this.showAlert(this.modelService.getString('builder_error_max_length_title'), mensaje);
			}
			localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));

			//############################################################################
			//############################################################################
			//## USO EXCLUSIVO PARA DESARROLLO, SOLO SE CUMPLE EN LOCAL.
			//if (document.location.origin.includes('localhost:7890')) {
			//	if (!verPresupuesto) this.currentViewMode = this.VIEW_MODE.M3D;
			//	return;
			//}
			//############################################################################
			//############################################################################

			if (verPresupuesto) {
				// Hacer la petición a Node para que devuelva el presupuesto calculado.
				let subs: Subscription = this.builderService.budget(this.projectData).subscribe(
					(response) => {
						// Si todo fue bien redireccionamos al detalle del proyecto.
						subs.unsubscribe();
						this.projectData = response;
						//this.onProjectUpdate();
						this.saveToNode();
						localStorage.setItem(Utils.PREVIOUS_CURRENT_PROJECT, this.projectData._id);
						this.router.navigate(['/project-detail']);
					},
					(error) => {
						// Puede que Navision no esté operativo.
						console.warn('Budget', error);
						this.showAlert(this.modelService.getString('satelite3d_error_titulo'),
							this.modelService.getString('presupuesto_error_mensaje'));
					});
			}
			else {
				// Se han hecho los calculos de los prímetros, ahora se llama al 3D.
				this.currentViewMode = this.VIEW_MODE.M3D;
			}
		}
		else if (this._tiempoMaxWaitBudget > 6000) {
			console.warn('Budget:: Tiempo límite pasado.');
			if (verPresupuesto) {
				this.showAlert(this.modelService.getString('satelite3d_error_titulo'),
					this.modelService.getString('presupuesto_error_mensaje'));
			}
			else {
				this.showAlert(this.modelService.getString('satelite3d_error_titulo'),
					this.modelService.getString('satelite3d_error_mensaje'));
			}
		}
		else {
			setTimeout(() => {
				this._tiempoMaxWaitBudget += 300;
				this.waitBudgetSatelite(verPresupuesto);
			}, 300);
		}
	}

	private showAlert(title: string, mensage: string) {
		const alertData = new AlertData();
		alertData.title = title;
		alertData.messages = mensage.split('#');
		alertData.type = AlertDataTypes.ACCEPT;
		this.alertWindow.show(alertData);
	}

	// ### Pantalla completa.
	public toggleFullscreen(activate: boolean) {

		const docEl = document.documentElement as HTMLElement & {
			mozRequestFullScreen(): Promise<void>;
			webkitRequestFullscreen(): Promise<void>;
			msRequestFullscreen(): Promise<void>;
		};

		const doc = document as Document & {
			mozCancelFullScreen(): Promise<void>;
			webkitExitFullscreen(): Promise<void>;
			msExitFullscreen(): Promise<void>;
		};

		if (activate) {
			if (docEl.requestFullscreen) {
				docEl.requestFullscreen();
			} else if (docEl.mozRequestFullScreen) { /* Firefox */
				docEl.mozRequestFullScreen();
			} else if (docEl.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
				docEl.webkitRequestFullscreen();
			} else if (docEl.msRequestFullscreen) { /* IE/Edge */
				docEl.msRequestFullscreen();
			}
		}
		else {
			if (doc.exitFullscreen) {
				doc.exitFullscreen();
			} else if (doc.mozCancelFullScreen) { /* Firefox */
				doc.mozCancelFullScreen();
			} else if (doc.webkitExitFullscreen) { /* Chrome, Safari and Opera */
				doc.webkitExitFullscreen();
			} else if (doc.msExitFullscreen) { /* IE/Edge */
				doc.msExitFullscreen();
			}
		}
		/* if(activate && !document.fullscreenElement){ document.documentElement.requestFullscreen(); } else if(!activate){  document.exitFullscreen(); }*/
	}

	// ### Captura cuando se pasa de FullScreen a normal y viceversa.
	public onToggleChange() {
		// Cambiar.
		this.fullscreen = !this.fullscreen;
		Utils.DOM_WebHeader_show(!this.fullscreen);

		this.toggleFullscreen(this.fullscreen);
	}

	// Captura cuando cambia el zoom.
	public onZoomChange(zoom: number) {
		this.currentMap.setZoom(this.currentMap.getZoom() + zoom);
	}

	// ### Historial.
	public canHistorialNext() { return this.historialService.hasHistorialForward; }			// MVC
	public canHistorialBack() { return this.historialService.hasHistorialBackward; }		// MVC

	// ### Devuelto por ubicador.
	public refreshPosition(latLng: any): void {
		this.lat = latLng.lat;
		this.projectData.satelite.lat = this.lat;
		this.lng = latLng.lng;
		this.projectData.satelite.lng = this.lng;
	}

	// ###
	public getPerimeterTotalLength(): number {
		return this.projectData.perimetro.reduce((prev, current) => { return prev + (current ? current.longitud : 0); }, 0);
	}

	// ### Habilita o deshabilita las opciones de ver presupuesto y cambiar de view 2D/3D.center			MVC
	public get readyForRender(): boolean {
		if (this.projectData.estado > 0) return true;				// Si no es Borrador, puede ver el 3D.
		if (!this.projectData.perimetro) return false;				// Debe existir el objeto perímetro.
		if (this.projectData.perimetro.length == 0) return false;	// Debe existir como mínimo un perímetro.
		for (let p of this.projectData.perimetro) {
			if (p.coordenadas.length < 2) return false;
			if (!p.producto) return false;							// Debe existir un producto.
			if (!p.producto.panel) return false;					// Debe existir un panel.
			if (!p.producto.tipoPanel) return false;				// Debe existir un tipo de panel.
			for (let d of p.puertas) {
				if (!d.puerta) return false;						// Hay puertas pero no se ha seleccionado el tipo.
			}
		}
		return !(this.currentDrawing === MODE.DRAW);

		/*	const rs: any[] = this.projectData.perimetro && this.projectData.perimetro.length > 0 && this.currentDrawing !== MODE.DRAW
				&& this.projectData.perimetro.filter((perimetro) => {
					return perimetro === undefined || perimetro.producto === undefined
						|| perimetro.producto.panel === undefined
						|| perimetro.puertas.filter((puerta) => { return puerta.puerta === undefined; }).length > 0;
				});
			return rs.length === 0;*/
	}

	// ### Cambiar del view 2D al 3D y viceversa.
	public onViewChange(newMode: string) {
		// Menú, fue eliminado.
		//this.modelService.closeMenuContextEditors.emit('');

		// No puede cambiar de view si está en modo edición.
		// console.log("[gmaps-renderer] onViewChange init");
		if (this.currentViewMode === newMode) return;

		if (newMode === this.VIEW_MODE.M2D) {
			this.store.dispatch(actionsPath.iDontComingFrom3D());
			this.projectData = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));
			this.angularPatetico = true;
			this.currentViewMode = newMode;
			// console.log("[gmaps-renderer] onViewChange this.VIEW_MODE.M2D");
			//setTimeout(() => { this.updateSateliteMaps(); }, 200);
		}
		else {
			this.store.dispatch(actionsPath.iComingFrom3D());
			// Calcular el presupuesto pero no lo muestra y no pide los precios.
			this.loading = true;
			this.create3D();
		}
		// Almacena el actual view.
		//this.currentViewMode = newMode;
	}

	// ### Muestra u oculta el control de localización google (solo se ve en la view 2D).			MVC
	public get searchBoxVisibled(): boolean { return this.currentViewMode === this.VIEW_MODE.M2D; }

	// ### Salva el actual proyecto en local y en Node.
	private saveToNode() {
		if (!this.projectData._id || this.projectData._id === '' || !this.projectData.perimetro) return;
		if (!this.projectData.nombre || this.projectData.nombre.trim() === '') return;

		for (let perimeter of this.projectData.perimetro) {
			if (!perimeter.coordenadas || perimeter.coordenadas.length == 0) return;
		}

		let str = JSON.stringify(this.projectData);
		localStorage.setItem(Utils.CURRENT_PROJECT, str);
		this.builderService.saveProject(this.projectData).subscribe(
			(result) => { },
			(error) => { console.log(error); }
		);
	}
	// ### Da el total de la suma de todos los perímetros en formato string y teniendo en cuenta los puntos y comas.			MVC
	//public getPerimeterTotalLengthStr(): string { return Utils.formatDecimal(Utils.formatDecimal(this.getPerimeterTotalLength().toFixed(2), 2)); }
}












/*
	// FIX ME public getcurrentScale(): number {
		const ratios: any = { 20: 0.08, 19: 0.19, 18: 0.37, 17: 0.74, 16: 1.48, 15: 3, 14: 6, 13: 12, 12: 24, 11: 48, 10: 95, 9: 191 };
		return ratios[this.currentZoom] * 100;
	}
*/

